import React from 'react';
import { DropdownIndicator } from '../utils/constants';
import Select, { StylesConfig } from 'react-select';

interface CustomInputProps {
	placeholder?: string;
	option?: any;
	style: any;
	changeValue: (event: any) => void;
	defaultValue?: any;
	isDisabled?: boolean;
	tooltipTitle?: string;
}

const DropdownInput = (props: CustomInputProps) => {
	const { changeValue, defaultValue, isDisabled = false, tooltipTitle = '' } = props;

	// CONTROLLED native <select>: keep the shown option in sync with state via an
	// internal value, so it cannot drift like the previous uncontrolled defaultValue
	// (matches the controlled native selects on /suche). Seeded from defaultValue and
	// re-seeded if the pre-selection changes (e.g. the mobile Kaufen/Wohnung defaults
	// applied at mount).
	const [nativeValue, setNativeValue] = React.useState(
		defaultValue ? String(defaultValue.value) : ''
	);
	React.useEffect(() => {
		setNativeValue(defaultValue ? String(defaultValue.value) : '');
	}, [defaultValue]);

	// Native <select> onChange gives a string; the shared `changeDropDownValue`
	// handler expects a react-select-shaped option object ({ id, label, value }).
	// Reconstruct the chosen option so Redux/search behaviour stays identical.
	const handleNativeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		setNativeValue(e.target.value);
		const chosen = (props.option || []).find((o: any) => String(o.value) === e.target.value);
		if (chosen) changeValue(chosen);
	};

	return (
		<div className='cursor-pointer dropdown-input' title={tooltipTitle}>
			{/* Desktop (≥577px): the existing react-select, unchanged */}
			<div className='dropdown-desktop'>
				<Select
					components={{ DropdownIndicator }}
					className='react-select-container z-index--3'
					classNamePrefix='react-select'
					styles={props.style as StylesConfig}
					options={props.option}
					name={props.placeholder}
					isSearchable={false}
					placeholder={props.placeholder}
					onChange={(event) => changeValue(event)}
					defaultValue={defaultValue}
					isDisabled={isDisabled}
					// menuIsOpen={true}
				/>
			</div>

			{/* Phone (≤576px): native <select> → OS picker. Full-width, ≥16px font,
			    no inline scrollbar, real touch target. Toggled via @include phone. */}
			<div className='dropdown-mobile'>
				<select
					className='native-select'
					value={nativeValue}
					disabled={isDisabled}
					aria-label={props.placeholder}
					onChange={handleNativeChange}
				>
					<option value='' disabled>
						{props.placeholder}
					</option>
					{(props.option || []).map((o: any, i: number) => (
						<option key={i} value={String(o.value)}>
							{o.label}
						</option>
					))}
				</select>
			</div>
		</div>
	);
};

export default DropdownInput;
